import React from 'react';
import { Card } from 'primereact/card';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useNavigate } from 'react-router-dom';
import PrivacyPolicyContent from '../../shared/content/PrivacyPolicyContent';

const DashboardPrivacyPolicy = () => {
    const navigate = useNavigate();

    const breadcrumbItems = [
        { label: 'Dashboard', command: () => navigate('/app/dashboard') },
        { label: 'Legal' },
        { label: 'Privacy Policy' }
    ];

    const home = { icon: 'pi pi-home', command: () => navigate('/app/dashboard') };

    return (
        <div className="surface-0">
            <div className="mb-3">
                <BreadCrumb model={breadcrumbItems} home={home} />
            </div>
            
            {/* Hero Section with Gradient - Same as public page */}
            <div className="relative overflow-hidden border-round-xl shadow-2 mb-5" style={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                minHeight: '250px' 
            }}>
                <div className="absolute w-full h-full opacity-10">
                    <div className="absolute" style={{ 
                        top: '-5%', 
                        left: '80%',
                        width: '250px',
                        height: '250px',
                        borderRadius: '50%',
                        background: 'white'
                    }}></div>
                </div>
                
                <div className="relative z-1 px-4 py-6 md:py-8 text-center text-white">
                    <i className="pi pi-shield text-4xl md:text-6xl mb-3 md:mb-4 opacity-90"></i>
                    <h1 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4">Privacy Policy</h1>
                    <p className="text-base md:text-lg opacity-80 px-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
                        Your privacy is important to us. This policy outlines how we protect your information.
                    </p>
                </div>
            </div>
            
            <Card className="border-0 shadow-2">
                <PrivacyPolicyContent showHeroCards={true} />
            </Card>
        </div>
    );
};

export default DashboardPrivacyPolicy;